import React, { Component } from 'react';
import FormSectionWrapper, { FormSectionDescription, FormSectionTitle } from './styled/FormSection';
export default class FormSection extends Component {
  render() {
    const {
      title,
      description,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(FormSectionWrapper, null, title && /*#__PURE__*/React.createElement(FormSectionTitle, null, title), description && /*#__PURE__*/React.createElement(FormSectionDescription, null, description), children);
  }

}